import { DoubleCheckOrderIcon } from "../_icons/doubleCheckOrderIcon";

export const DoubleCheckOrderBanner = () => {
  return (
    <div
      data-testid="double-check-order-banner"
      className="flex gap-5 bg-[#EEFBFC] rounded-lg px-4 mx-4 text-[#373737]"
    >
      <DoubleCheckOrderIcon className="py-[18px]" />
      <div data-testid="double-check-order-text" className="text-xs py-4">
        <span className="font-semibold">Double check your order. </span>
        <span>
          Some items may not be editable after sending to the kitchen.
        </span>
      </div>
    </div>
  );
};
